import { REQUEST_CRITERIA, RECEIVE_CRITERIA, FAILURE_CRITERIA } from './constants';
import { combineReducers } from 'redux';

/*
 * State shape
 {
    criteria: {
        [type]: {criteria object}
    },
    error: '',
    fetching: false
 }
 */

const criteria = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_CRITERIA:
            return { ...state, [action.criteriaType]: action.response.payload };
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_CRITERIA:
            return true;
        case FAILURE_CRITERIA:
        case RECEIVE_CRITERIA:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_CRITERIA:
            return action.response.message;
        case REQUEST_CRITERIA:
        case RECEIVE_CRITERIA:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    criteria,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/criteria/reducer.js